export default __webpack_public_path__ + "static/media/add-contact-success.33f03a6c.svg";